<template>
  <div class="h-full">
    <div class="flex h-full justify-end items-center">
      <vs-dropdown
        style="margin-left: 5px; cursor: pointer"
        vs-custom-content
        vs-trigger-click
      >
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-more-vertical"
        ></vs-button>

        <vs-dropdown-menu style="min-width: 100px">
          <vs-dropdown-item
            v-if="checkEditPermission()"
            @click="openEditView(params.data)"
            >Edit</vs-dropdown-item
          >
          <vs-dropdown-item
            v-if="
              checkDeletePermission()"
            @click="openConfirm(params.data.id)"
            >Delete</vs-dropdown-item
          >
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </div>
</template>

<script>
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  mixins: [PermissionMiddleware],
  name: 'CellRendererAction',
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Subject')
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

    openEditView (editingObject) {
      this.params.colDef.filterParams.editSub(editingObject)
    }, 
    openConfirm (id) {
      this.params.colDef.filterParams.openConfirm(id)
    }
  }
}
</script>